import { useContext } from 'react';
import { GraphqlErrorsContext } from 'contexts/graphql-errors-context';

const useGraphqlErrors = () => useContext(GraphqlErrorsContext);

export default useGraphqlErrors;
